import { retrieveTargets as apiRetrieveTargets } from '@/api/api'

export default {

  RETRIEVE_TARGETS: ({ commit }) => {
    return apiRetrieveTargets().then(responseData => {
      commit('SET_TARGETS', { targets: responseData.response.data })
    }).catch(error => Promise.reject(error.response.data))
  }
}
